import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
// 1. IMPORTAMOS GRID DE SEMANTIC UI
import { Grid, Header } from "semantic-ui-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Module3.scss";

const virtualScenesController = new VirtualScenes();

export function Module3({ refId }) {
  const module3 = "module_03";
  const { accessToken } = useAuth();
  
  // ... (la lógica de React permanece sin cambios)
  const [moduleData, setModuleData] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module3
      );
      setModuleData(data.moduleData);

      if (data.moduleData?.ModThreeImagesObjetives) {
        const imageRequests = data.moduleData.ModThreeImagesObjetives.map(async (id) => {
          const imageData = await virtualScenesController.getRepoScene(id, accessToken);
          return imageData.url;
        });
        const imageUrls = await Promise.all(imageRequests);
        setImages(imageUrls);
      }
    } catch (err) {
      console.error("", err);
      setError("");
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module3]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading) return <div></div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="module3-container">
      <Header as="h2" className="block-title">
        {moduleData?.ModThreeTitle || "Título no disponible"}
      </Header>

      <div
        className="module3-content"
        dangerouslySetInnerHTML={{ __html: moduleData?.ModThreeContent || "" }}
      ></div>

      {/* 2. NUEVA ESTRUCTURA GRID PARA CARRUSEL Y SUBCONTENIDO */}
      <Grid stackable columns={2} className="carousel-grid">
        {/* Columna Izquierda: Carrusel */}
        <Grid.Column width={8}>
          <div className="module3-carousel">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              loop={true}
            >
              {images.map((url, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={url}
                    alt={`Imagen ${index + 1}`}
                    className="module3-carousel-image"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Grid.Column>

        {/* Columna Derecha: Subcontenido */}
        <Grid.Column width={8}>
          <div
            className="module3-subcontent"
            dangerouslySetInnerHTML={{ __html: moduleData?.ModThreeSubcontent || "" }}
          ></div>
        </Grid.Column>
      </Grid>
    </div>
  );
}